/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const eventBus = require('js-event-bus')();

export class EventbusService {
  private static instance: EventbusService;
  private readonly eventBus: any;

  private constructor(props: any = {}) {
    this.eventBus = eventBus;
  }

  public static getInstance(props: any = {}): EventbusService {
    if (!EventbusService.instance) {
      EventbusService.instance = new EventbusService(props);
    }
    return EventbusService.instance;
  }

  getEventBus() {
    return this.eventBus;
  }
}
